import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import "../Electrician/Electrician.css"
const Fridge = ({ cart, addToCart }) => {
  const navigate = useNavigate();
  const [openService, setOpenService] = useState(null);
  const services = [
    {
      id: 501,
      title: "Single Door Service Pack",
      price: 499,
      subtitle: "Full cleaning & performance check",
      extra_detail_1: "Complete cleaning for single door fridge",
      extra_detail_2: "Check cooling and internal components",
      image: "https://tiimg.tistatic.com/fp/3/007/891/single-door-refrigerator-267.jpg"
    },
    {
      id: 502,
      title: "Double Door Service Pack",
      price: 699,
      subtitle: "Deep cleaning + cooling check",
      extra_detail_1: "Deep clean double door refrigerator",
      extra_detail_2: "Inspect cooling and airflow performance",
      image: "https://media.tatacroma.com/Croma%20Assets/Large%20Appliances/Refrigerator/Images/269872_vb1mwt.png"
    },
    {
      id: 503,
      title: "Side-by-Side/ French Door Service pack",
      price: 899,
      subtitle: "Premium refrigerator maintenance",
      extra_detail_1: "Premium service for large refrigerators",
      extra_detail_2: "Ensure cooling efficiency and hygiene",
      image: "https://image.made-in-china.com/2f0j00hUFfGIWPqCgp/Side-by-Side-Double-Door-Refrigerator-No-Frost-Fridge-with-Ice-Maker.webp"
    },
    {
      id: 504,
      title: "General cleaning service",
      price: 499,
      subtitle: "Full inside cleaning & hygiene care",
      extra_detail_1: "Clean fridge interior shelves thoroughly",
      extra_detail_2: "Maintain hygiene and remove odor",
      image: "https://image.made-in-china.com/2f0j00hUFfGIWPqCgp/Side-by-Side-Double-Door-Refrigerator-No-Frost-Fridge-with-Ice-Maker.webp"
    },
    {
      id: 505,
      title: "Premium fridge service",
      price: 699,
      subtitle: "Triple/ French door/ Side-by-Side",
      extra_detail_1: "Premium service for advanced refrigerators",
      extra_detail_2: "Ensure optimal cooling performance",
      image: "https://image.made-in-china.com/2f0j00hUFfGIWPqCgp/Side-by-Side-Double-Door-Refrigerator-No-Frost-Fridge-with-Ice-Maker.webp"
    },
    {
      id: 506,
      title: "Fridge not cooling repair",
      price: 349,
      subtitle: "Fix cooling issues safely",
      extra_detail_1: "Diagnose and repair cooling problems",
      extra_detail_2: "Restore proper refrigerator temperature",
      image: "https://image.made-in-china.com/2f0j00hUFfGIWPqCgp/Side-by-Side-Double-Door-Refrigerator-No-Frost-Fridge-with-Ice-Maker.webp"
    },
    {
      id: 507,
      title: "Power / wiring issue repair",
      price: 299,
      subtitle: "Fix electrical or power problems",
      extra_detail_1: "Repair faulty wiring and connections",
      extra_detail_2: "Restore stable refrigerator power supply",
      image: "Power / wiring issue repair"
    },
    {
      id: 508,
      title: "Water leakage repair",
      price: 399,
      subtitle: "Fix leaking inside or outside",
      extra_detail_1: "Fix internal or external leakage",
      extra_detail_2: "Ensure proper drainage and sealing",
      image: "https://www.mrrooter.com/us/en-us/mr-rooter/_assets/images/mrr-blog-us-water-leaking-from-refrigerator1.webp"
    },
    {
      id: 509,
      title: "Noise / vibration repair",
      price: 349,
      subtitle: "Fix unusual sound & shaking issues",
      extra_detail_1: "Fix unusual fridge noise problems",
      extra_detail_2: "Stabilize compressor and internal parts",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTYy6xbkc_tjY9IXL2eH4naZ11kJCgo1pLNWQ&s"
    },
    {
      id: 510,
      title: "Gas refill (Home fridge)",
      price: 1800,
      subtitle: "Gas refill + leakage & cooling test",
      extra_detail_1: "Refill refrigerant gas for cooling",
      extra_detail_2: "Check leakage and cooling efficiency",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTumWW_CJxq6kmb9j067J_kkKZBhgvXSrcJ3A&s"
    },
    {
      id: 511,
      title: "Compressor health check",
      price: 299,
      subtitle: "Full compressor performance test",
      extra_detail_1: "Inspect compressor condition and operation",
      extra_detail_2: "Ensure stable cooling performance",
      image: "https://rukminim2.flixcart.com/image/480/480/l4n2oi80/refrigerator-compressor/n/y/r/500-4587-zubi-original-imagfhzzwyvwm7dg.jpeg?q=90"
    },
    {
      id: 512,
      title: "Thermostat / Sensor Repair",
      price: 499,
      subtitle: "Fix temperature & auto cut-off problems",
      extra_detail_1: "Repair faulty thermostat or sensors",
      extra_detail_2: "Restore accurate temperature control",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRCDOouajf_C_eo3CBWxpbcC7WIuPKwRIZ8Ag&s"
    },
    {
      id: 513,
      title: "Deep Freezer Service",
      price: 899,
      subtitle: "Single / double door deep freezer service",
      extra_detail_1: "Complete cleaning for deep freezer",
      extra_detail_2: "Check freezing and cooling performance",
      image: "https://5.imimg.com/data5/FS/VW/MY-32148106/deep-freezer-refrigerator.jpg"
    },
    {
      id: 514,
      title: "Visi Cooler / Display Fridge",
      price: 999,
      subtitle: "Shop display fridge servicing",
      extra_detail_1: "Service display fridge cooling system",
      extra_detail_2: "Ensure stable cooling for beverages",
      image: "https://m.media-amazon.com/images/I/71H+vqad47L._AC_UF1000,1000_QL80_.jpg"
    },
    {
      id: 515,
      title: "Commercial Gas Refill",
      price: 2600,
      subtitle: "Gas refill with cooling test",
      extra_detail_1: "Refill gas for commercial refrigerators",
      extra_detail_2: "Check leakage and cooling performance",
      image: "https://m.media-amazon.com/images/I/71H+vqad47L._AC_UF1000,1000_QL80_.jpg"
    },
    {
      id: 516,
      title: "Commercial Cooling Repair",
      price: 899,
      subtitle: "Cooling failure / heavy load repair",
      extra_detail_1: "Repair cooling issues in commercial units",
      extra_detail_2: "Restore stable cooling performance",
      image: "https://m.media-amazon.com/images/I/71H+vqad47L._AC_UF1000,1000_QL80_.jpg"
    }
  ]
  return (
    <div className='container-fluid service-electrician'>
      <div id="Electronic">
        <h1>Fridge services</h1>
      </div>
      <div className='elect-container'>
        <div className="services-section-elect">
          {services.map((service) => {
            const isAdded = cart.some(
              item => item.id === service.id && item.category === service.category
            );
            return (
              <div key={service.id} className="service-card-elect">

                <div className="service-details-elect">
                  <h3>{service.title}</h3>

                  <div className="price-section-elect">
                    <span className="new-price-elect">₹{service.price}</span>
                  </div>
                  <button
                    className=" btn btn-link view-details-elect"
                    onClick={() =>
                      setOpenService(openService === service.id ? null : service.id)
                    }
                  >
                    View Details
                  </button>
                  {openService === service.id && (
                    <div className="extra-details-elect">
                      <p>✔ {service.extra_detail_1}</p>
                      <p>✔ {service.extra_detail_2}</p>
                    </div>
                  )}

                  <ul>
                    <li>{service.subtitle}</li>
                  </ul>
                </div>

                <div className="service-image-elect">
                  <img src={service.image} alt="" /><br />
                  <button
                    onClick={() => addToCart(service)}
                    className={`btn px-5 mt-2 ${isAdded ? "btn-success" : "btn-warning"
                      }`}
                  >
                    {isAdded ? "Added" : "Add"}
                  </button>
                </div>

              </div>
            );
          })}
        </div>
      </div>
    </div>
  )
}

export default Fridge